import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import { Link } from 'react-router-dom';
import { getArticleRel, getArticleURL, getArticleImageUrl } from '../utils';
export var getCommonsProps = function getCommonsProps(_ref) {
  var _ref$withAuthorImage = _ref.withAuthorImage,
    withAuthorImage = _ref$withAuthorImage === void 0 ? false : _ref$withAuthorImage,
    article = _ref.article,
    _ref$tagsQty = _ref.tagsQty,
    tagsQty = _ref$tagsQty === void 0 ? 2 : _ref$tagsQty,
    _ref$dataFiEvent = _ref.dataFiEvent,
    dataFiEvent = _ref$dataFiEvent === void 0 ? 'article-card' : _ref$dataFiEvent,
    _ref$isClient = _ref.isClient,
    isClient = _ref$isClient === void 0 ? false : _ref$isClient,
    withImage = _ref.withImage,
    imagePosition = _ref.imagePosition,
    imageWidth = _ref.imageWidth;
  var title = article.title,
    socialStats = article.socialStats;
  var tags = socialStats.tags;
  var displayTags = socialStats.tags.slice(0, tagsQty);
  var metaDescription = article.body.metadata.description;
  var url = getArticleURL(article, isClient);
  var rel = getArticleRel(article);
  var date = article.revision.updated || article.revision.created;
  var flexProps = imagePosition === 'up' ? {
    align: 'row',
    direction: 'column'
  } : {
    align: 'row',
    direction: 'row'
  };
  var linkProps = url.startsWith('/') ? {
    to: url,
    as: Link,
    'data-fi-event': dataFiEvent,
    title: title,
    rel: rel
  } : {
    href: url,
    as: 'a',
    'data-fi-event': dataFiEvent,
    title: title,
    rel: rel
  };
  var imageUrl = withImage ? getArticleImageUrl(article, withAuthorImage, imageWidth) : null;
  return {
    tags: tags,
    metaDescription: (metaDescription || '').trim(),
    displayTags: displayTags,
    linkProps: linkProps,
    imageUrl: imageUrl,
    url: url,
    rel: rel,
    date: date,
    flexProps: flexProps
  };
};